module.exports = __webpack_public_path__ + "img/workout-notebook_B095GG2L8X.8bc81485.jpg";